import i18n from 'services/i18n'
import singleCertificateHelper from '../helpers/singleCertificateHelper'
import listCertificateHelper from '../helpers/listCertificateHelper'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'
import { groupBy } from 'lodash'
const unitForHour = 't'

function createSingleCertificate (course) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    certificate = singleCertificateHelper.setupNewPdfPage(certificate)
    singleCertificateHelper.resetStartCoordinate()

    singleCertificateHelper.setCertificateLabel(certificate, course)
    singleCertificateHelper.setCompletedOnDate(certificate, course)
    singleCertificateHelper.setCourseTitle(certificate, course)
    singleCertificateHelper.setCourseDescription(certificate, course)
    singleCertificateHelper.setUserNameHasCompletedCourse(certificate, course)
    singleCertificateHelper.setCourseInstructor(certificate, course)
    singleCertificateHelper.setCourseType(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCoursePublishDate(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCourseCategories(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCourseLevel(certificate, course)
    singleCertificateHelper.setCourseDuration(certificate, course, 't')
    singleCertificateHelper.setAuthorizations(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setContactInfo(certificate)
    if (singleCertificateHelper.isDigitalClassRoom(course)) {
        singleCertificateHelper.setDigitalClassRoomTrainingDate(certificate, course)
    }

    if (singleCertificateHelper.isLearningPath(course)) {
        singleCertificateHelper.addInfoTextForListOfCourses(certificate)

        let pageNumber = 1
        let courseListNumber = 1
        let rowCoordinate = 72
        let totalDuration = 0

        singleCertificateHelper.addPageNumber(certificate, pageNumber)
        pageNumber++
        certificate.addPage()
        listCertificateHelper.setupNewPdfPage(certificate)
        listCertificateHelper.addPageNumber(certificate, pageNumber)
        listCertificateHelper.addLearningPathCourseListParagraph(certificate, course.learningPathName)
        listCertificateHelper.setCertificateListLabel(certificate, true)
        certificate = listCertificateHelper.setColumnLabels(certificate)
        singleCertificateHelper.setContactInfo(certificate)

        course.courseCertificates.forEach((courseCertificate) => {
            if (rowCoordinate > 217) {
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                rowCoordinate = 63
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
            }
            certificate.setTextColor('black')
            certificate.setFontSize(8)
            certificate.setFont('Nunito-Regular')
            certificate.text(11, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 95)
            certificate.text(18, rowCoordinate, splitTitle)

            listCertificateHelper.setAuthorizationsForIndividualCourse(certificate, courseCertificate, rowCoordinate)
            certificate.text(182, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)
            // Apply the space for titles longer than 1 row
            rowCoordinate += (4 * (splitTitle.length - 1))

            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null) {
                certificate.text(18, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') + ' | ' + listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1
            rowCoordinate += 13

            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (courseCertificate.durations.length - 2) * 4
            }

            totalDuration += parseInt(courseCertificate.duration)
        })

        const authorizationsByCategory = groupAuthorizationsByCategory(course.courseCertificates)
        let authorizationHorizontalCoordinate = 249
        let authorizationVerticalCoordinate = 12
        certificate.setFont('Nunito-Regular')
        certificate.setFontSize(9)

        for (const authorization in authorizationsByCategory) {
            certificate.text(authorizationVerticalCoordinate, authorizationHorizontalCoordinate, authorization + ': ' + authorizationsByCategory[authorization] + ' t')
            authorizationHorizontalCoordinate += 4
            if (authorizationHorizontalCoordinate === 277) {
                authorizationHorizontalCoordinate = 249
                authorizationVerticalCoordinate += 85
            }
        }
        certificate.setTextColor('white')
        certificate.setFontSize(14)
        certificate.setFont('Nunito-Regular')
        certificate.setTextColor('black')
        certificate.setFontSize(14)
        certificate.text(12, 243.5, i18n.t('CertificateList.no_total_authorizations'))
        certificate.setTextColor('#e47700')

        certificate = singleCertificateHelper.setContactInfo(certificate)
        certificate = listCertificateHelper.setTotalWatchedAmountLabel(certificate, totalDuration, 't', singleCertificateHelper.isLearningPath(course))
    }

    certificate.setTextColor('black')
    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate')
    })
    window.open(certificate.output('bloburl'))
}
function createListCertificate (filteredCourseList) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    certificate = listCertificateHelper.setupNewPdfPage(certificate)
    let courseListNumber = 1
    let rowCoordinate = 72
    let pageNumber = 1
    let totalDuration = 0
    let courseIds = []

    certificate = listCertificateHelper.setCertificateListLabel(certificate)
    certificate = listCertificateHelper.setUserNameHasCompletedCourses(certificate, filteredCourseList)
    certificate = listCertificateHelper.setColumnLabels(certificate)

    if (filteredCourseList.learningPaths.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_learning_paths'))
    }

    filteredCourseList.learningPaths.forEach((learningPath) => {
        courseListNumber = 1
        if (rowCoordinate > 219) {
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            rowCoordinate = 72
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
        }
        certificate.setFont('icomoon')
        certificate.setFontSize(11)
        certificate.text(12, rowCoordinate, '')
        certificate.setFont('Nunito-Bold')
        certificate.setFontSize(9)
        let splitTitle = certificate.splitTextToSize(learningPath.title.replace(/"/g, ''), 130)
        certificate.text(19, rowCoordinate, splitTitle)
        certificate.setFontSize(9)
        certificate.text(182, rowCoordinate, formattedDateForCountry(learningPath.certificate.date))
        rowCoordinate += 6

        learningPath.certificate.courseCertificates.forEach((courseCertificate) => {
            certificate.setFontSize(9)
            certificate.setFont('Nunito-Regular')
            certificate.text(22, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 90)
            certificate.text(28, rowCoordinate, splitTitle)

            certificate.setFontSize(9)

            listCertificateHelper.setAuthorizationsForIndividualCourse(certificate, courseCertificate, rowCoordinate)
            certificate.text(182, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)

            // Apply the space for titles longer than 1 row
            rowCoordinate += (4 * (splitTitle.length - 1))
            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null) {
                certificate.text(28, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') + ' | ' + listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1
            // Apply the space for authorization types
            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (4 * (courseCertificate.durations.length + 1))
            } else {
                rowCoordinate += 13
            }
            if (courseCertificate.duration) {
                totalDuration += parseInt(courseCertificate.duration)
            }
            courseIds.push(courseCertificate.courseId)
            if (rowCoordinate > 219) {
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                rowCoordinate = 72
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
            }
        })
    })

    rowCoordinate += 7
    courseListNumber = 1
    const listableCourses = filteredCourseList.courses.filter(course => !courseIds.includes(course.id))
    if (listableCourses.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_courses'))
    }
    listableCourses.forEach((course) => {
        let courseCertificate = course.certificate
        if (rowCoordinate > 219) {
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            rowCoordinate = 72
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
        }
        certificate.setTextColor('black')
        certificate.setFontSize(8)
        certificate.setFont('Nunito-Regular')
        certificate.text(13, rowCoordinate, courseListNumber.toString() + '.')
        let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 95)
        certificate.text(18, rowCoordinate, splitTitle)

        listCertificateHelper.setAuthorizationsForIndividualCourse(certificate, courseCertificate, rowCoordinate)
        certificate.text(182, rowCoordinate, formattedDateForCountry(courseCertificate.date))
        certificate.setFontSize(8)
        certificate.setFont('Nunito-Regular')
        // Apply the space for titles longer than 1 row
        rowCoordinate += (4 * (splitTitle.length - 1))

        if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null) {
            certificate.text(18, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') + ' | ' + listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
        }
        courseListNumber += 1
        // Apply the space for authorization types
        if (courseCertificate.durations.length > 2) {
            rowCoordinate += (4 * (courseCertificate.durations.length + 1))
        } else {
            rowCoordinate += 13
        }
        totalDuration += parseInt(courseCertificate.duration)
    })

    const authorizationsByCategory = groupAuthorizationsByCategory(filteredCourseList.courses.map(course => course.certificate))
    let authorizationHorizontalCoordinate = 249
    let authorizationVerticalCoordinate = 12
    certificate.setFont('Nunito-Regular')
    certificate.setFontSize(9)

    for (const authorization in authorizationsByCategory) {
        certificate.text(authorizationVerticalCoordinate, authorizationHorizontalCoordinate, authorization + ': ' + authorizationsByCategory[authorization] + ' t')
        authorizationHorizontalCoordinate += 4
        if (authorizationHorizontalCoordinate === 277) {
            authorizationHorizontalCoordinate = 249
            authorizationVerticalCoordinate += 85
        }
    }
    certificate.setTextColor('white')
    certificate.setFontSize(14)
    certificate.text(11, 236, i18n.t('CertificateList.courses_watched_total') + ' ' + listCertificateHelper.convertMinutesToHours(totalDuration, unitForHour))
    certificate.setFont('Nunito-Bold')
    certificate.setTextColor('black')
    certificate.setFontSize(14)
    certificate.text(12, 243.5, i18n.t('CertificateList.no_total_authorizations'))
    certificate.setTextColor('#e47700')

    certificate = singleCertificateHelper.setContactInfo(certificate)

    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate_list')
    })
    window.open(certificate.output('bloburl'))
}
function groupAuthorizationsByCategory (courseCertificates) {
    let categoryCredits = []
    courseCertificates.forEach((courseCertificate) => {
        courseCertificate.durations.forEach((authorization) => {
            categoryCredits.push(getAuthorizationItem(courseCertificate, authorization))
        })
    })
    categoryCredits = groupBy(categoryCredits, 'categoryName')
    for (let categoryCredit in categoryCredits) {
        categoryCredits[categoryCredit] = categoryCredits[categoryCredit].map(credit => credit.duration)
            .reduce((previous, current) => previous + current, 0)
    }
    return categoryCredits
}
function getAuthorizationItem (completedCourse, authorization) {
    return {
        categoryName: authorization.category,
        duration: +authorization.credits
    }
}

export default {
    createSingleCertificate,
    createListCertificate,
}
